import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerStandardChartFormatting } from './utils/chartFormatting';

registerStandardChartFormatting();

/** After a dev-server restart or deploy, the browser may keep an old bundle.js that references removed chunk hashes. */
function installChunkLoadRecovery(): void {
  if (typeof window === 'undefined') return;
  const reloadOnce = (reason: string) => {
    const key = 'climateplans-chunk-reload';
    if (sessionStorage.getItem(key) === reason) return;
    sessionStorage.setItem(key, reason);
    window.location.reload();
  };
  window.addEventListener('unhandledrejection', (event) => {
    const msg = String((event.reason as Error)?.message ?? event.reason ?? '');
    if (/Loading chunk|ChunkLoadError|dynamically imported module/i.test(msg)) {
      reloadOnce(msg.slice(0, 120));
    }
  });
  window.addEventListener('error', (event) => {
    const msg = String(event.message ?? '');
    if (/Loading chunk|ChunkLoadError/i.test(msg)) {
      reloadOnce(msg.slice(0, 120));
    }
  });
}
installChunkLoadRecovery();

// Apply saved theme before first paint to avoid flash
const savedTheme = typeof window !== 'undefined' && window.localStorage.getItem('climateplans-theme');
const initialTheme = savedTheme === 'dark' || savedTheme === 'light' ? savedTheme : 'light';
document.documentElement.setAttribute('data-theme', initialTheme);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
